module.exports = __webpack_public_path__ + "static/media/ADRIAN_CLAYBORN_TEXTURE_CUSTOM.f0942df0.png";